import "prebid.js/modules/admaticBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {MonetixAdsAdUnit} from "header-bidding-base/modules/config/domain/bidders/monetixAdsConfig";

export class MonetixAdsBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<MonetixAdsAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.MONETIXADS);
    }
}
